import { isComboPackage } from './promotionTypes.js'
import { buildCartComboGroupMutation } from './cartComboGroupMutation.js'

const normalizeQuantity = (value) => Math.max(1, Math.trunc(Number(value) || 1))

const resolveMutationQuantity = (item, options = {}) =>
  options.basketCount == null ? item.quantity : options.basketCount

const buildAddPayload = (item, newSkuId, options) => ({
  prodId: item.prodId,
  skuId: newSkuId,
  basketCount: normalizeQuantity(resolveMutationQuantity(item, options)),
  isChecked: item.checked ? 1 : 0,
  promotionType: 0,
})

/**
 * Build the cart mutation needed when switching a cart line to another SKU.
 * Normal lines are add-then-delete so changeItem/v3 can merge with an existing target SKU.
 * Combo package lines atomically replace the complete group because their SKU identity cannot be
 * patched independently from the package membership.
 *
 * @param {Object} item
 * @param {number|string} newSkuId
 * @param {{basketCount?: number|string, groupRows?: Array<Object>, leaderBasketId?: number|string}} [options]
 * @returns {{mode: 'replace', changeItems: Object} | {mode: 'addThenDelete', addPayload: Object, deleteBasketIds: Array<number|string>}}
 */
export const buildCartSpecChangeMutation = (item, newSkuId, options = {}) => {
  if (isComboPackage(item?.promotionType)) {
    const groupRows = Array.isArray(options.groupRows) ? options.groupRows : []
    if (!groupRows.length) throw new Error('组合规格修改缺少完整购物车组')

    const targetBasketId = String(item?.basketId ?? item?.id ?? '')
    const selectedRows = groupRows.map((row) =>
      String(row?.basketId ?? row?.id ?? '') === targetBasketId
        ? { ...row, skuId: newSkuId }
        : row
    )

    return buildCartComboGroupMutation({
      group: {
        rows: groupRows,
        selectBasketId:
          options.leaderBasketId ?? item?.comboGroupLeaderBasketId ?? item?.basketId ?? item?.id,
      },
      selectedRows,
      getQuantity: (row) =>
        String(row?.basketId ?? row?.id ?? '') === targetBasketId
          ? normalizeQuantity(resolveMutationQuantity(item, options))
          : normalizeQuantity(row?.quantity),
    })
  }

  return {
    mode: 'addThenDelete',
    addPayload: buildAddPayload(item, newSkuId, options),
    deleteBasketIds: [item.basketId],
  }
}
